/*global FormController*/
var createCustomFilterPopupController = new FormController("iz_custom_filter", 
    {
        directory: "views/customFilters",
        name: "createCustomFilterPopup",
        route: "create-custom-filter",
        buttonsHTML: "<!-- no button -->",
        nocache: true, //no cache because the column field must be recompute for each screen
        openInPopup: true,
        noTitle: true,
        popup: {
            //size can by small, medium, large and wide
            size: "wide"
        },
        joinFetch: [
            { otherTable : "iz_custom_filter_column", name: "lines", type:"2many" }
        ]
    }
);

//handle the opening parameters
createCustomFilterPopupController.prepareDataOnEnter = function(data, callback){
    if(!data || typeof(data) === "object"){
        //received a full object or nothing, go ahead with it
        return callback(null, data) ;
    }
    //receive an id, read the record from database
    this.api.db.iz_custom_filter.searchFirst({id: data}, [
        { otherTable : "iz_custom_filter_column", name: "lines", type:"2many"}
    ], function(err, record){
        if(err){ return callback(err) ;}
        record.lines.forEach(function(line){
            if(line.value1 && line.value1[0] === "[" && line.value1[line.value1.length-1] === "]"){
                line.value1 = JSON.parse(line.value1) ;
            }
            line.value_computed = line.value1 ;
        }) ;
        callback(null, record) ;
    }.bind(this)) ;
} ;

//the popup will never be in read mode, switch to create or modify
createCustomFilterPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        if(!this.data.id){
            this.setMode("create") ;
        }else{
            this.setMode("modify") ;
        }
    }
} ;

createCustomFilterPopupController.onRender = function(){
    this.view.ensureDisplayed(function(){
        this.data.lines.forEach(function(line, i){
            if(line.column){
                var instance = this.view.views[Object.keys(this.view.views)[0]].instances[i] ;
                if(instance){
                    this.onColumn({source: instance}) ;
                }
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

createCustomFilterPopupController.onColumn = function(ev){
    var line = ev.source.updateData() ;
    ev.source.EL.fieldValue1.innerHTML = "" ;
    if(!line.column){ return ; }
    var el = document.createElement("DIV") ;
    ev.source.getElement(ev.source.EL.fieldValue1).appendChild(el) ;
    this.view.longTask(function(done){
        ev.source.createFieldWithSchema(el, this.data.tableName, line.column, {statesAsSelection: true}, function(err){
            if(err){ return done(err) ; }
            ev.source.getElement(ev.source.EL.fieldValue1).getValue = el.getValue.bind(el) ;
            ev.source.getElement(ev.source.EL.fieldValue1).setValue = el.setValue.bind(el) ;
            ev.source.getElement(ev.source.EL.fieldValue1).setReadOnly = el.setReadOnly.bind(el) ;
            ev.source.render();
            const fieldType = el.getAttribute('data-field');
            if(fieldType){ 
                const fieldType = el.getAttribute('data-field');
                line.fieldType = fieldType
            }
            ev.source.render();
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

createCustomFilterPopupController.onOperator = function (ev) {
    // Update the data for the current line
    const line = ev.source.updateData();
    const parentLineEl = ev.source.container;

    if (ev.data.currentData && ev.data.currentData.operator === "=") {
        const value1Field = parentLineEl.querySelector('[data-original-id="fieldValue1"]');
        if (!value1Field) {
            return;
        }

        const innerField = value1Field.querySelector('.form-group');
        if (!innerField) {
            return;
        }

        const fieldType = innerField.getAttribute('data-field');
        if (fieldType) {
            line.fieldType = fieldType;
        }
    }
    ev.source.render();
};

createCustomFilterPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};

//close when user click on cancel button
createCustomFilterPopupController.onCancel = function(){
    this.view.close() ;
};

createCustomFilterPopupController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    viewData.lines.forEach(function(line){
        if(line.computed_value){
            line.value1 = line.value_computed ;
        }
    }) ;
    FormController.prototype.getRecordsToSave.call(this, viewData, dataBeforeModif, callback) ;
} ;

//save and close on validate
createCustomFilterPopupController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

//save and close on validate
createCustomFilterPopupController.onRemove = function(){
    this.view.longTask(function(done){
        this.api.db.iz_custom_filter.remove({id: this.data.id}, function(err){
            if(err){ return done(err); }

            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = createCustomFilterPopupController ;